class CDistilleryHero extends HTMLElement {
  constructor() {
    super();
    this.slides = [];
    this.dots = [];
    this.currentIndex = 0;
    this.autoplayTimer = null;
  }

  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.c-distillery-hero__slide'));
    this.dots = Array.from(this.querySelectorAll('.c-distillery-hero__dot'));
    if (this.slides.length <= 1) return;

    this.querySelectorAll('.c-distillery-hero__arrow').forEach((btn) => {
      btn.addEventListener('click', () => {
        this.go(btn.dataset.direction === 'next' ? 1 : -1);
      });
    });

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        this.setIndex(parseInt(dot.dataset.index, 10));
      });
    });

    if (this.dataset.autoplay === 'true') {
      const speed = (parseInt(this.dataset.autoplaySpeed, 10) || 5) * 1000;
      this.autoplayTimer = setInterval(() => this.go(1), speed);
      this.addEventListener('mouseenter', () => clearInterval(this.autoplayTimer));
      this.addEventListener('mouseleave', () => {
        this.autoplayTimer = setInterval(() => this.go(1), speed);
      });
    }
  }

  disconnectedCallback() {
    if (this.autoplayTimer) clearInterval(this.autoplayTimer);
  }

  go(step) {
    const next = (this.currentIndex + step + this.slides.length) % this.slides.length;
    this.setIndex(next);
  }

  setIndex(index) {
    this.slides[this.currentIndex].classList.remove('is-active');
    this.dots[this.currentIndex]?.classList.remove('is-active');
    this.currentIndex = index;
    this.slides[this.currentIndex].classList.add('is-active');
    this.dots[this.currentIndex]?.classList.add('is-active');
  }
}

customElements.define('c-distillery-hero', CDistilleryHero);
